import { render } from "./DbsParkStockAndEmpty.vue?vue&type=template&id=edfad57c&scoped=true"
import script from "./DbsParkStockAndEmpty.vue?vue&type=script&lang=js"
export * from "./DbsParkStockAndEmpty.vue?vue&type=script&lang=js"

import "./DbsParkStockAndEmpty.vue?vue&type=style&index=0&id=edfad57c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-edfad57c"

export default script